import React, { useEffect } from "react";
import { Col, Row, Checkbox, List, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getQuestionAnswerAction } from "../../../../store/pages/plans/actions";
import { RootState } from "../../../../store";
import { selectStore } from "../../../../store/selector";
import { MyBreadcrumb, MyText } from "../../../../components";
import { setTestResultByStudent } from "../../../../store/pages/journal/actions";
import {
  CheckOutlined,
  CheckSquareOutlined,
  CloseOutlined,
  CloseSquareOutlined,
  WarningOutlined
} from "@ant-design/icons";
import { TextEditor } from "../../../../components/common/TextEditor";


const SEARCH_PARAMS = {
  SDOT_TYPE: 'sdotType',
  STUDENT_ID: 'studentId',

  CTP_ID: 'ctpId',
  JOURNAL_START_DATE: 'start_date',
  JOURNAL_END_DATE: 'end_date',
}


export const TestView = () => {
  const { t } = useTranslation("common")

  const dispatch = useDispatch()
  const { testId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  const studentId = searchParams.get(SEARCH_PARAMS.STUDENT_ID)

  useEffect(() => {
    dispatch(getQuestionAnswerAction(testId))
    dispatch(setTestResultByStudent({
      test_id: testId,
      student_id: studentId,
    }))
  }, [])

  const { plans: { oneTest: testState }, journal: { testResult: testResultState } }: RootState = useSelector(selectStore)

  const currentTestResult = testResultState.data?.[0]

  const questions = () => {
    const currentQuestions = testState.data?.questions
    const currentTestResult = testResultState.data?.[0]

    const current = currentQuestions?.map((item: any) => ({
      ...item,
      answers: item?.answers?.map((answer: any) => ({
        ...answer,
        students_answer: currentTestResult?.answers?.[item?.id]?.some((current: any) => current?.id === answer?.id)
      }))
    }))

    console.log('current', current)

    return current
  }

  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')


  const answers = (answer: any) => {
    if (answer?.is_correct && answer?.students_answer) {
      return <CheckOutlined style={{ fontSize: 18, color: '#51258F' }} />
    } else if (!(answer?.is_correct) && answer?.students_answer) {
      return <CloseOutlined style={{ fontSize: 18, color: '#DA192C' }} />
    } else {
      return false
    }
  }

  const answerBackground = (answer: any) => {
    if (answer?.is_correct && answer?.students_answer) {
      return {
        background: '#E6F3E5',
        border: '#88C94D'
      }
    } else if (!(answer?.is_correct) && answer?.students_answer) {
      return {
        background: '#FEEEEE',
        border: '#EE4D4D'
      }
    } else {
      return {
        background: '#fff',
        border: '#fff',
      }
    }
  }


  return (
    <>
      <MyBreadcrumb title={t('back')} isBack />

      <Row justify='center'>
        <Col span={20}>
          <Card>
            <List
              dataSource={questions()}
              loading={testState.loading}
              rowKey={(record: any) => record.id}
              header={<MyText weight={700} size={24}>{testState.data?.name}</MyText>}
              renderItem={(item: any, index: any) => {
                return (
                  <List.Item>
                    <Row style={{ width: '100%' }} gutter={[16, 16]}>
                      <Col span={24}>
                        <MyText weight={500} size={18} color={'var(--c-hover)'}>
                          <TextEditor
                            value={index + 1 + "." + item.name}
                            disabled={true}
                          />
                        </MyText>
                      </Col>

                      <Col span={24}>
                        <Row align='middle' gutter={[16, 6]}>
                          {item.answers.map((answer: any, answerIndex: any) => (
                            <Col key={answer.id} span={24}>
                              <Card bodyStyle={{
                                padding: 6,
                                backgroundColor: answerBackground(answer)?.background,
                                borderRadius: 8,
                                borderColor: 'transparent'
                                // borderWidth: 1,
                                // borderStyle: 'solid',
                                // borderColor: answerBackground(answer)?.border
                              }} style={{ borderColor: 'transparent' }}>
                                <Row justify='space-between' align='middle'>
                                  <Col>
                                    <Row align='middle' gutter={6}>
                                      <Col>
                                        <MyText weight={500} size={18} color={'var(--c-subtitle)'}>
                                          <TextEditor
                                            value={alphabet[answerIndex].toUpperCase()}
                                            disabled={true}
                                          />
                                        </MyText>
                                      </Col>

                                      <Col>
                                        <MyText weight={500} size={18} color={'var(--c-title-text)'} lineHeight='24px'>
                                          <TextEditor
                                            value={answer.name}
                                            disabled={true}
                                          />
                                        </MyText>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col>
                                    <div style={{ marginRight: 8 }}>
                                      {answers(answer)}
                                    </div>
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </List.Item>
                )
              }}
            />
          </Card>
        </Col>
      </Row>
    </>
  )
}